import React, { useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../css/Navbar.css';

const Navbar = () => {
    const location = useLocation(); // Hook pour récupérer l'URL actuelle
    const collapseRef = useRef(null);

    // Referme le menu burger (mobile) après un clic sur un lien
    const fermerMenu = () => {
        const el = collapseRef.current;
        if (el && el.classList.contains('show') && window.bootstrap) {
            window.bootstrap.Collapse.getOrCreateInstance(el, { toggle: false }).hide();
        }
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/" onClick={fermerMenu} style={{ height: '120px', marginTop: '20px' }}>
                    <img src="/img/la_clef-copie3.png" alt="Home" />
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup" ref={collapseRef}>
                    <div className="navbar-nav" onClick={(e) => e.target.closest('.nav-link') && fermerMenu()}>
                        <Link className={`nav-link ${location.pathname === '/Validation' ? 'active' : ''}`} to="/Validation">Validation</Link>
                        <Link className={`nav-link ${location.pathname === '/AideDeJeu' ? 'active' : ''}`} to="/AideDeJeu">Aide de jeu</Link>
                        <Link className={`nav-link ${location.pathname === '/Univers' ? 'active' : ''}`} to="/Univers">Univers</Link>
                        <Link className={`nav-link ${location.pathname === '/Bonus' ? 'active' : ''}`} to="/Bonus">Bonus</Link>
                        <Link className="nav-link" aria-current="page" target="_blank" to="https://discord.gg/invite/sTkE7vz">Discord</Link>
                        <Link className="nav-link" aria-current="page" target="_blank" to="https://www.fanelia.art/22-la-clef">Boutique</Link>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;